"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  confirm: '确定',
  cancel: '取消'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/PopConfirm/locale/zh_CN.js
// module id = 1912
// module chunks = 6 7 17 18